define('controller/disclosure/disclosure.list.controller',['require','exports','module','fukit','underscore','view/disclosure/disclosure.list.page.view','model/disclosure.documents.model','model/disclosure.unsubmitted.report.model','model/disclosure.detail.model','backbone.radio','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController                     = require('fukit').BaseController,
      _                                  = require('underscore'),
      DisclosureListPageView             = require('view/disclosure/disclosure.list.page.view'),
      DocumentsModel                     = require('model/disclosure.documents.model'),
      DisclosureUnsubmittedReportModel   = require('model/disclosure.unsubmitted.report.model'),
      DisclosureDetailModel              = require('model/disclosure.detail.model'),
      Radio                              = require('backbone.radio'),
      ROLES                              = require('fukit').Roles;

  if (!localStorage.getItem('productNewCoiUi')) {
    var coiModel;
    var productNewCoiUiValue = false;
    const enabledProductCollection = Radio.request('AppKit.resourceService', 'resource', 'enabledProductCollection');

    if (!_.isUndefined(enabledProductCollection)) {
      coiModel = enabledProductCollection.findWhere({ name: 'COI', active: true });
      const dataModel = coiModel.collection.models;
      const filteredDataArray = dataModel.filter(function(item) {
        return item.attributes.name === 'COI' && item.attributes.active === true;
      });
      productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
    }

    if (productNewCoiUiValue) {
      localStorage.setItem('productNewCoiUiValue', productNewCoiUiValue.toString());
      location.assign(location.origin + '/coi-react/disclosure/list');
    }
  }

  var DisclosureListController = BaseController.extend({
    radioRequests: {
      'controllers DisclosureListController': '@constructor',
    },

    pageView: DisclosureListPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      disclosureCollection: {
        fetchOnStart: true,
        collection: DisclosureDetailModel.Collection.extend({
          sort: {
            field: 'createDate',
            direction: 'descending',
          },
        }),
      },

      disclosureUnsubmittedReportModel: {
        model: DisclosureUnsubmittedReportModel,
      },
    },

    onStart: function() {
      if (this.state.get('disclosureStatus')) {
        this.getResource('disclosureCollection').filters.add({
          field: 'status',
          value: this.state.get('disclosureStatus'),
        });
      }

      var controller = this;

      this.listenTo(this.getResource('disclosureCollection'), 'sync', function(collection) {
        var modelsArray = collection.models;
        for (var i = 0; i < modelsArray.length; i++) {
          var disclosureId = modelsArray[i].get('id');
          var model = modelsArray[i];

          model.set('documents', []);

          var documentsCollection = new DocumentsModel.Collection();

          documentsCollection.filters.addFilterWithField({ name: 'attachmentPoint' }).equals(disclosureId);

          if (documentsCollection) {
            documentsCollection
              .fetch()
              .promise()
              .then(function(result) {
                var documents = result._embedded.fileDbs;
                if (documents) {
                  var disclosuresList = controller.resources.disclosureCollection.models;
                  var targetModel;

                  for (var c = 0; c < disclosuresList.length; c++) {
                    var targetId = documents[0].attachmentPoint;

                    if (targetId == disclosuresList[c].get('id')) {
                      targetModel = disclosuresList[c];
                    }
                  }
                  targetModel.set('documents', documents);
                }
              })
              .bind(this)
              .catch(function(error) {
                console.error('An error occurred while fetching documents:', error);
              });
          }
        }
      });
    },
  });

  module.exports = DisclosureListController;
});

